import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=45fe4fa2&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fe4fa2')) {
      api.createRecord('45fe4fa2', component.options)
    } else {
      api.reload('45fe4fa2', component.options)
    }
    module.hot.accept("./AuthLayout.vue?vue&type=template&id=45fe4fa2&", function () {
      api.rerender('45fe4fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Auth/Components/AuthLayout.vue"
export default component.exports